import { Model, attr } from 'redux-orm';
import { createAction, createLoadConst, createUpdateConst } from '../util';

export default class GuestLoans extends Model {
  static get modelName() {
    return 'GuestLoans';
  }

  static get options() {
    return {
      idAttribute: 'number',
    };
  }

  static reducer({ type, data = {} }, GuestLoans) {
    switch (type) {
      case LOAD.SUCCESS: {
        GuestLoans.delete();
        const loans = Array.isArray(data?.response)
          ? data.response
          : data?.response?.payload?.loans || data?.response?.loans || [];
        loans.forEach((r) => {
          const existing = GuestLoans.withId(r.number);
          const historyTransactions = existing?.historyTransactions || [];
          const scheduledTransactions = existing?.scheduledTransactions || [];
          GuestLoans.create({
            ...r,
            historyTransactions,
            scheduledTransactions,
          });
        });
        break;
      }
      case LOAD_HISTORY.SUCCESS: {
        const { loanNumber, transactions } = data;
        const loan = GuestLoans.withId(loanNumber);
        if (loan) {
          loan.update({ historyTransactions: transactions });
        } else {
          GuestLoans.create({
            number: loanNumber,
            historyTransactions: transactions,
          });
        }
        break;
      }
      case LOAD_SCHEDULED.SUCCESS: {
        const { loanNumber, transactions } = data;
        const loan = GuestLoans.withId(loanNumber);
        if (loan) {
          loan.update({ scheduledTransactions: transactions });
        } else {
          GuestLoans.create({
            number: loanNumber,
            scheduledTransactions: transactions,
          });
        }
        break;
      }
      case CANCEL_GUEST_SCHEDULED.SUCCESS: {
        const { loanNumber, scheduleId } = data;
        const loan = GuestLoans.withId(loanNumber);
        if (loan) {
          // Update the specific transaction status to 'canceled'
          const scheduledTransactions = loan.scheduledTransactions.map((txn) =>
            txn.id === scheduleId ? { ...txn, status: 'canceled' } : txn
          );
          loan.update({ scheduledTransactions });
        }
        break;
      }
      case LOAD.FAILURE:
        GuestLoans.delete();
        break;
      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */

  static get fields() {
    return {
      id: attr(),
      number: attr(),
      loans: attr(),
      loanNumber: attr(),
      type: attr(),
      numberSuffix: attr(),
      status: attr(),
      email: attr(),
      ownerType: attr(),
      sortBy: attr(),
      sortDirection: attr(),
      payers: attr(),
      historyTransactions: attr(),
      scheduledTransactions: attr(),
      // Guest transaction history fields
      sendOn: attr(),
      deliverOn: attr(),
      processOn: attr(),
      scheduleSendOn: attr(),
      scheduleDeliverOn: attr(),
      frequency: attr(),
      confirmationNumber: attr(),
      fundingAccount: attr(),
      destination: attr(),
      payerName: attr(),
      payerPhone: attr(),
      recipientName: attr(),
      coreAccountType: attr(),
      coreAccountNumberMask: attr(),
      a2atracenumber: attr(),
      description: attr(),
      termsAndConditionsUrl: attr(),
      createdAt: attr(),
      updatedAt: attr(),
      amount: attr(),
      feeAmount: attr(),
    };
  }
}

const name = GuestLoans.modelName;

export const LOAD = createUpdateConst(name);
export const load = createAction(LOAD);

export const LOAD_ID = createLoadConst(`${name}_id`);
export const loadById = createAction(LOAD_ID);

export const LOAD_HISTORY = createUpdateConst(`${name}_HISTORY`);
export const LOAD_SCHEDULED = createUpdateConst(`${name}_SCHEDULED`);
export const CANCEL_GUEST_SCHEDULED = createUpdateConst(
  `${name}_CANCEL_SCHEDULED`
);

export const loadHistory = createAction(LOAD_HISTORY);
export const loadScheduled = createAction(LOAD_SCHEDULED);
export const cancelGuestScheduled = createAction(CANCEL_GUEST_SCHEDULED);
